export var getSlateSpacingPixels = function(spacing) {
    return spacingToNumberMap[spacing];
};
export var getSlateSpacingPixelsString = function(spacing) {
    return "".concat(getSlateSpacingPixels(spacing), "px");
};
// Spacing values come from https://www.figma.com/file/s7VxgVsNoO1smpdecnUYoN/Faire-Slate?type=design&node-id=4449-12646&mode=design&t=crJA1bdzBVGLE3uu-0
var spacingToNumberMap = {
    XXXL: 72,
    XXL: 48,
    XL: 32,
    L: 24,
    R: 16,
    S: 12,
    XS: 8,
    XXS: 4,
    XXXS: 2,
    SPACING_NONE: 0,
    SPACING_UNKNOWN: 0
};
